var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockquote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 16,
    viewBox: "0 0 26 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.80357 15.5101H7.16741L10.7433 9.51273V0.516602H0.015625V9.51273H5.37946L1.80357 15.5101ZM16.1071 15.5101H21.471L25.0469 9.51273V0.516602H14.3192V9.51273H19.683L16.1071 15.5101Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockquote);
export default __webpack_public_path__ + "static/media/blockquote.70a84932ddc84e71ac3ec28b91ab96c6.svg";
export { ForwardRef as ReactComponent };